import React, { CSSProperties, FC, PropsWithChildren, ReactNode } from 'react'

import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

const Text = styled.div`
  margin-top: 5px;
  font-size: 13px;
`

const Content = styled.div`
  margin-top: 10px;
`

export interface UserCardProps extends PropsWithChildren {
  title: ReactNode
  text: ReactNode | string
  style?: CSSProperties
}

export const UserCard: FC<UserCardProps> = ({
  title,
  text,
  children,
  style,
}) => {
  return (
    <Container>
      {title}

      <Text style={style}>{text}</Text>
      {children && <Content>{children}</Content>}
    </Container>
  )
}
